import { Suspense, useEffect } from 'react'
import { useParams } from 'react-router'
import { useDispatch, useSelector } from 'react-redux'
import FieldSkeleton from '@/shared/components/FieldSkeleton'
import CommonFallback from '@/shared/components/CommonFallback'
import useOfferEditForm from '@/containers/OrganizationsManagement/OfferForm/useOfferEditForm'
import useOfferEdit from '@/containers/OrganizationsManagement/OfferForm/useOfferEdit'
import { selectOrganizationsSelectedProvider } from '@/containers/OrganizationsManagement/organizationsManagementSelectors'
import { organizationsManagementActions } from '@/containers/OrganizationsManagement/organizationsManagementSagas'
import useBusinessType from '@/shared/hooks/useBusinessType'
import SaveEnergyOffer from '@/containers/OrganizationsManagement/OfferForm/Energy/SaveEnergyOffer'
import SaveTelecomOffer from '@/containers/OrganizationsManagement/OfferForm/Telecom/SaveTelecomOffer'
import SaveInsuranceOffer from '@/containers/OrganizationsManagement/OfferForm/Insurance/saveInsuranceOffer'

const saveFnByType = {
  energie: SaveEnergyOffer,
  telecom: SaveTelecomOffer,
  assurance: SaveInsuranceOffer,
}

const OfferEdit = () => {
  const { providerUuid } = useParams()
  const dispatch = useDispatch()
  const selectedProvider = useSelector(selectOrganizationsSelectedProvider)
  const { type } = useBusinessType({ loaderRoutesEnergy: {}, loaderRoutes: {}, loaderRoutesInsurance: {} })
  const { LocalizedModule } = useOfferEditForm()
  const { saveOffer, isLoading } = useOfferEdit(saveFnByType[type])

  useEffect(() => {
    if (providerUuid && !selectedProvider.uuid) {
      dispatch({ type: organizationsManagementActions.LOAD_PROVIDER, providerId: providerUuid })
    }
  }, [providerUuid])

  if (!LocalizedModule) {
    return
  }

  if (isLoading) {
    return <CommonFallback />
  }

  return (
    <Suspense fallback={<FieldSkeleton />}>
      <LocalizedModule saveOffer={saveOffer} />
    </Suspense>
  )
}

export default OfferEdit
